import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Module, Right} from '../../models/models';
import {Translation} from '../../models/translation';
import {LoginService} from '../../services/login.service';
import {UserService} from '../../services/user.service';
import {ChangePasswordService} from '../../services/change-password.service';
import Swal from 'sweetalert2';
import {sha256} from 'js-sha256';

@Component({
  selector: 'app-administration',
  styleUrls: ['./administration.component.css'],
  templateUrl: './administration.component.html',
})
export class AdministrationComponent implements OnInit {

  public translation: Translation;
  public userManagementModule: Module;
  public mailServiceModule: Module;
  // public fotoboxSettingModule: Module;
  public apiTokenModule: Module;
  public passwordChangeModule: Module;
  public logoutModule: Module;
  public rightStatus: number;
  public rights: Right[];
  public tempPw2: string;
  public tempPw3: string;

  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private changePasswordService: ChangePasswordService,
    private router: Router,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.translation = JSON.parse(localStorage.getItem('Translation'));
    this.rightStatus = +sessionStorage.getItem('RightStatus');
    this.rights = JSON.parse(sessionStorage.getItem('Rights'));

    // UserManagement
    this.userManagementModule = new Module();
    this.userManagementModule.ModuleName = this.translation.UserManagementCardTitle;
    this.userManagementModule.ModuleDesc = this.translation.UserManagementCardDesc;
    this.userManagementModule.ModuleButtonText = this.translation.Manage;
    this.userManagementModule.ForwardLink = '/usermanagement';

    if (this.rightStatus <= 1) {
      this.mailServiceModule = new Module();
      this.mailServiceModule.ModuleName = 'MailDienst';
      this.mailServiceModule.ModuleDesc = 'Verwalten Sie die Mails, die das Cotraportal versendet.';
      this.mailServiceModule.ModuleButtonText = 'Verwalten';
      this.mailServiceModule.ForwardLink = '/mailService';

      // this.fotoboxSettingModule = new Module();
      // this.fotoboxSettingModule.ModuleName = 'Fotobox-Einstellung';
      // this.fotoboxSettingModule.ModuleDesc = 'Fotobox-Dateiverteilung nach individueller Konfiguration.';
      // this.fotoboxSettingModule.ModuleButtonText = 'Verwalten';
      // this.fotoboxSettingModule.ForwardLink = '/fotoboxSetting';

      this.apiTokenModule = new Module();
      this.apiTokenModule.ModuleName = 'API-Token';
      this.apiTokenModule.ModuleDesc = 'API-Token erstellen.';
      this.apiTokenModule.ModuleButtonText = 'Verwalten';
      this.apiTokenModule.ForwardLink = '/apiToken';
    }

    // PasswordChangeModule
    this.passwordChangeModule = new Module();
    this.passwordChangeModule.ModuleName = this.translation.PasswordChange;
    this.passwordChangeModule.ModuleDesc = '';
    this.passwordChangeModule.ModuleButtonText = this.translation.Change;
    this.passwordChangeModule.ForwardLink = 'PasswordChange';

    // LogoutModule
    this.logoutModule = new Module();
    this.logoutModule.ModuleName = this.translation.Logout;
    this.logoutModule.ModuleDesc = '';
    this.logoutModule.ModuleButtonText = this.translation.Logout;
    this.logoutModule.ForwardLink = 'Logout';
  }

  navigate(forwardLink: string) {
    const tempWnSpecial = sessionStorage.getItem('WheelnewsSpecial');
    switch (forwardLink) {
      case 'PasswordChange': this.changePassword(); break;
      case 'Logout':
        sessionStorage.clear();
        if (tempWnSpecial != null) {
          this.router.navigate(['/' + tempWnSpecial + 'login']);
        } else {
          this.router.navigate(['/login']);
        }
        break;
      default: this.router.navigate([forwardLink]);
    }
  }

  changePassword() {
    this.userService.getUserById(+sessionStorage.getItem('UserId')).subscribe(responseUser => {
      if (responseUser.Ok) {
        Swal.mixin({
          input: 'password',
          inputValidator: (value) => {
            if (responseUser.Obj.Password !== sha256(value)) { return this.translation.OldPasswordNotCorrectMessage; }
            return !value && this.translation.YouHaveToEnterAPassword;
          },
          confirmButtonColor: '#CC0000',
          allowOutsideClick: false,
          showCancelButton: true,
          showConfirmButton: true,
          reverseButtons: true,
          cancelButtonText: this.translation.Cancel,
          confirmButtonText: this.translation.Next + ' &rarr;',
          progressSteps: ['1', '2', '3']
        }).queue([
          {
            title: this.translation.PasswordChange,
            text: this.translation.OldPassword,
            inputValidator: (value) => {
              if (responseUser.Obj.Password !== sha256(value)) { return this.translation.OldPasswordNotCorrectMessage; }
              return !value && this.translation.YouHaveToEnterAPassword;
            },
            currentProgressStep: '0'
          },
          {
            title: this.translation.PasswordChange,
            text: this.translation.NewPassword,
            inputValidator: (value) => {
              this.tempPw2 = value;
              return !value && this.translation.YouHaveToEnterAPassword;
            },
            currentProgressStep: '1'
          },
          {
            title: this.translation.PasswordChange,
            text: this.translation.RepeatPassword,
            inputValidator: (value) => {
              this.tempPw3 = value;
              if (this.tempPw2 !== this.tempPw3) { return this.translation.RepeatPasswordNotCorrectMessage; }
              return !value && this.translation.YouHaveToRepeatTheNewPassword;
            },
            currentProgressStep: '2'
          }
        ]).then((result: any) => {
          if (result.value) {
            this.changePasswordService.updatePasswordWithoutToken(responseUser.Obj.UserId, this.tempPw2).subscribe(response => {
              if (response.Ok) {
                if (response.Obj) {
                  Swal.fire({title: this.translation.PasswordChanged, icon: 'success', confirmButtonColor: '#CC0000'});
                }
              } else if (response.Msg === 'Internal Server Error') { console.log(response.Ex); }
              if (response.Msg) { this.toast.fire({title: response.Msg, icon: response.Ok ? 'success' : 'error'}); }
            }, error => { this.toast.fire(this.translation.InternalServerError); });
          }
        });
      } else if (responseUser.Msg === 'Internal Server Error') { console.log(responseUser.Ex); }
      if (responseUser.Msg) { this.toast.fire({title: responseUser.Msg, icon: responseUser.Ok ? 'success' : 'error'}); }
    }, error => { this.toast.fire(this.translation.InternalServerError); });
  }
}
